import { Component } from 'react';

import { Col, Row } from 'reactstrap';

import Hr from '../hr/hr';
import { formatResultTime } from '../../../services/time/time-service';
import AngleChart from './angle-chart/angle-chart';
import FormSection from '../form-section/form-section';
import HandpathGraph from './handpath-graph';
import MetaData from './meta-data';
import moment from 'moment-es6';
import './result.css';

const containerWidth = { width: 400 };

class Result extends Component {
  constructor() {
    super();
    this.state = {
      showingMeta: false,
      showingMeasurement: false,
    };
  }

  render() {
    return this.result();
  }

  prepareLabel(str) {
    return str.replace(/_/g, ' ').replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  toggleMetaData() {
    const newShowMetaState = !this.state.showingMeta;

    this.setState({ showingMeta: newShowMetaState });
  }

  toggleMeasurementData() {
    const newShowMeasurement = !this.state.showingMeasurement;

    this.setState({ showingMeasurement: newShowMeasurement });
  }

  exportHandpathData() {
    const { result } = this.props;
    const _created = result && new Date(result.created);
    const createdDisplay = _created && moment(_created).format('MM-DD-YYYY-h-mm-a');

    const element = document.createElement('a');
    const file = new Blob([result.handpath], { type: 'text/plain;charset=utf-8' });
    element.href = URL.createObjectURL(file);
    element.download = result.game_name + '_' + createdDisplay + '.txt';
    document.body.appendChild(element);
    element.click();
  }

  result = () => {
    const { activityCard, result } = this.props;

    const isOutOfGym = result.out_of_gym;

    const gotMeasurementData = result.measurement_data ? true : false;

    let measurementTitle = '';
    let measurementData = false;

    if (gotMeasurementData) {
      measurementData = JSON.parse(result.measurement_data);
      if (measurementData.measurement_name) {
        measurementTitle = this.prepareLabel(measurementData.measurement_name);
      } else {
        measurementTitle = this.prepareLabel(measurementData.mode);
      }

      measurementData = measurementData.data;
    }

    const _created = result && new Date(result.created);
    const createdDisplay = _created && moment(_created).format('MM/DD/YYYY HH:MM');
    const toggleMetaDataText = this.state.showingMeta ? 'Hide Additional info' : 'Show Additional info';
    const noActivitiesComponenet = (
      <Col className="mp-0" id={result.id}>
        <Row className="m-0 pl-2 pr-0 py-0 text-left">
          <div className="mp-0">
            <h6 className="mp-0">
              Game:
              <span className="mx-2 my-0 p-0 small text-secondary">{result.game_name}</span>
            </h6>
          </div>
          <div className="ml-auto mr-2 my-0 p-0 text-right">
            <h6 className="mp-0">
              Played:
              <span className="mx-2 my-0 p-0 small text-secondary">{createdDisplay}</span>
            </h6>
          </div>
        </Row>
        <Row className="m-0 pl-2 pr-0 py-0 text-left">
          <div className="mp-0">
            <h6 className="mp-0">
              Duration:
              <span className="mx-2 my-0 p-0 small text-secondary">{formatResultTime(result.duration)}</span>
            </h6>
          </div>
          <div className="ml-auto mr-2 my-0 p-0 text-right">
            <h6 className="mp-0">
              <span className="mx-2 my-0 p-0 small text-secondary">{result.user}</span>
              {isOutOfGym && <span className="current_user">[Out of Gym]</span>}
            </h6>
          </div>
        </Row>
        <Row className="m-0 pl-2 pr-0 py-0 text-left">
          <h6 className="mp-0">
            Session Name:
            <span className="mx-2 my-0 p-0 small text-secondary">{result.session_name}</span>
          </h6>
        </Row>
        <Hr />
        {this.handpaths()}
        <button onClick={this.exportHandpathData.bind(this)} className="export_handpath">
          Export Raw Handpath
        </button>
        <Row className="m-0 pl-3 pr-0 py-0 text-left">
          <p className="mp-0">
            <span className="mp-0 small text-secondary">
              {result.skill} / {result.position} / {result.level}
            </span>
          </p>
        </Row>
        {result.meta_data && (
          <div>
            <div className="toggle_meta_data" onClick={this.toggleMetaData.bind(this)}>
              {toggleMetaDataText}
            </div>
            <MetaData data={JSON.parse(result.meta_data)} showing={this.state.showingMeta}></MetaData>
          </div>
        )}

        {gotMeasurementData && (
          <div>
            <div className="toggle_meta_data" onClick={this.toggleMeasurementData.bind(this)}>
              {measurementTitle}
            </div>
            <MetaData data={measurementData} showing={this.state.showingMeasurement}></MetaData>
          </div>
        )}
      </Col>
    );

    return (
      <div className="m-auto p-0" style={containerWidth}>
        <FormSection component={activityCard ? this.withActivities() : noActivitiesComponenet} />
      </div>
    );
  };

  handpaths = () => {
    const { result, ignoreHandpath } = this.props;
    const _resultType = result.result_type || 1;

    return (
      <div className="m-0 px-0 pt-1 pb-0">
        {!ignoreHandpath && _resultType === 1 && (
          <HandpathGraph
            handpath={result.handpath}
            screen_percentage={result.screen_percentage}
            game_type={result.game_type}
            game_id={result.game_id}
            result_id={result.id}
          />
        )}
        {!ignoreHandpath && _resultType === 2 && <AngleChart result={result} />}
      </div>
    );
  };

  withActivities = () => {
    const { activityCard } = this.props;

    return (
      <div>
        {activityCard}
        <div className="m-auto p-0">{this.handpaths()}</div>
      </div>
    );
  };
}

export default Result;
